/**
 * Shared disclaimer shown wherever CPE compliance fulfillment estimates are
 * displayed (user compliance page and admin team reporting page).
 */
export const FULFILLMENT_DISCLAIMER =
  'Compliance progress is estimated from credits recorded in CPAx Academy. Your State Board ' +
  'of Accountancy is the final authority on your CPE status.';

/** Shown on editable requirement cards during compliance setup. */
export const BOARD_AUTHORITY_DISCLAIMER =
  'Your state board is the authority on CPE requirements. Values shown here are provided for ' +
  'convenience; always verify with your board before relying on them.';
